import { acfApi, gFormApi, wpApi } from 'components/store/services/api'
import { AvailableLanguage } from 'components/core/types'

const wordpressApiService = {
  getCliniques: async (locale: AvailableLanguage) => {
    const config = await wpApi.get(`clinique?per_page=100&lang=${locale}`)
    return config.data ?? []
  },
  getOptions: async (locale: AvailableLanguage) => {
    const config = await acfApi.get(`options/options?lang=${locale}`)
    return config.data?.acf ?? {}
  },
  getRegions: async (locale: AvailableLanguage) => {
    const config = await wpApi.get(`region?per_page=100&lang=${locale}`)
    return config.data ?? []
  },
  getTreatments: async (locale: AvailableLanguage) => {
    const config = await wpApi.get(`clinique_treatment?per_page=100&lang=${locale}`)
    return config.data ?? []
  },
  saveAppointmentForm: async (formId, data) => {
    const { REACT_APP_GFORM_APIKEY, REACT_APP_GFORM_SECRET } = process.env
    const config = await gFormApi.post(`forms/${formId}/submissions`, {
      input_1: data.newPatient ? 'oui' : 'non',
      input_2: data.lastName,
      input_3: data.firstName,
      input_4: data.phone,
      input_5: data.email,
      input_6: data.message,
      input_7: data.clinique,
      input_8: data.personType,
      input_9: data.treatment,
      input_10: data.cliniqueEmail,
    }, {
      headers: {
        Authorization: `Basic ${REACT_APP_GFORM_APIKEY}:${REACT_APP_GFORM_SECRET}`,
      },
    })
    return config.data
  },
}
export default wordpressApiService
